import React from 'react';
import { PortalContext } from '../../../../../context/portal-context';
import { actionRedirect } from '../../../../../helpers/common-helpers';
import { HuchaTier, HuchaType } from '../models/hucha-values';
import { useHuchaTracker } from '../../hucha-venta/hooks/use-hucha-tracker';
import { useBonoPosventaTracker } from '../../bono-posventa/hooks/use-bono-posventa-tracker';

export const useCitaHandler = (huchaType: HuchaType, huchaTier?: HuchaTier) => {
	const { userInteractionService } = React.useContext(PortalContext);
	const { trackCitaConcesionarioClick } = useHuchaTracker(huchaTier ?? 'standard');
	const { trackCitaServicioOficialClick } = useBonoPosventaTracker();

	const handleCita = () => {
		if (huchaType === 'posventa') {
			trackCitaServicioOficialClick();
			actionRedirect(userInteractionService, 'es-cca-loader--open_layer');
		} else {
			trackCitaConcesionarioClick();
			actionRedirect(userInteractionService, 'es-oneform--lead-cita');
		}
	};
	return { handleCita };
};
